import _ from "lodash";
import * as Excel from "exceljs/dist/es5/exceljs.browser";

import {
  columnsHeader,
  columnsInvoices,
  columnsDeductions
} from "./columnsExcel";
import { getFormatted } from "helpers/formatting";
import { downloadFile } from "helpers/download";
import { getTranslation } from "helpers/common";

const alignment = { horizontal: "right" };
const style = { bold: true };
const borderStyles = {
  top: { style: "thin" },
  left: { style: "thin" },
  bottom: { style: "thin" },
  right: { style: "thin" }
};

export const downloadExcel = data => {
  const workbook = new Excel.Workbook();
  let cell;
  let newCell;
  let colAddress;
  let newAddress;
  let worksheet;
  let tempColumnHeader;
  let headers: any = [];

  _.map(data, dataItem => {
    return {
      headerDate: getFormatted(_.get(dataItem, "header.PaymentDate"), "date"),
      headerVersion: _.get(dataItem, "header.Version")
    };
  }).forEach(initialName => {
    tempColumnHeader = `${initialName.headerDate} (v${
      initialName.headerVersion
    })`;

    headers.push(tempColumnHeader);
  });

  headers = renameFiles(headers);

  _.each(data, (d, dataIndex) => {
    worksheet = workbook.addWorksheet(headers[dataIndex]);
    // add headers to sheet
    _.each(columnsHeader, header => {
      cell = worksheet.getCell(header.cell);
      cell.value = getTranslation(header.title);
      cell.font = style;
      colAddress = cell.col + (header.shift || 0);
      newAddress = worksheet.getColumn(colAddress).letter + cell.row;
      newCell = worksheet.getCell(newAddress);
      if (header.type === "date") {
        newCell.value = getFormatted(_.get(d.header, header.key), "date");
      } else {
        newCell.value = _.get(d.header, header.key, "-");
      }

      if (header.type === "currency") {
        cell.alignment = alignment;
        newCell.numFmt = "€ #,##0.00;€ -#,##0.00;0";
      }
    });

    // add invoices to sheet
    worksheet = addRows(d.invoices, worksheet, columnsInvoices, "INVOICES");
    // add deductions to sheet
    worksheet = addRows(
      d.deductions,
      worksheet,
      columnsDeductions,
      "DEDUCTIONS_BLOCKAGES"
    );

    // change width of columns
    _.each(columnsInvoices, (c, index) => {
      worksheet.getColumn(index + 1).width = c.width || 18;
    });
  });

  workbook.xlsx.writeBuffer().then(buffer => {
    const blob = new Blob([new Uint8Array(buffer)], {
      type: "application/xlsx"
    });
    downloadFile(blob, `${getTranslation("ACCOUNT_STATEMENTS")}.xlsx`);
  });
};

const renameFiles = arr => {
  const count = {};

  arr.forEach((element, index) => {
    if (arr.indexOf(element) !== index) {
      const elementCount =
        element in count
          ? (count[element] = count[element] + 1)
          : (count[element] = 1);
      let version = elementCount + 1;
      let renamedElement = element + " " + version;

      while (arr.indexOf(renamedElement) !== -1) {
        renamedElement = element + " " + ++version;
      }

      arr[index] = renamedElement;
    }
  });

  return arr;
};

const addRows = (array, worksheet, columns, headerText) => {
  let rowStart;
  let tempCell;
  worksheet.getCell(`A${worksheet.rowCount + 2}`).value = getTranslation(
    headerText
  );
  worksheet.getCell(`A${worksheet.rowCount}`).font = style;
  if (array.length > 0) {
    worksheet.addRows([_.map(columns, c => getTranslation(c.title))]);
    worksheet.getRow(worksheet.rowCount).font = style;
    rowStart = worksheet.rowCount;
    worksheet.addRows(
      _.map(array, item => {
        return _.map(columns, v => {
          if (v.type === "date") {
            return getFormatted(_.get(item, v.key), "date");
          }
          return _.get(item, v.key, "-");
        });
      })
    );

    _.each(columns, (c, index) => {
      _.each(_.range(rowStart, worksheet.rowCount + 1), (r, rowIndex) => {
        tempCell = worksheet.getCell(worksheet.getColumn(index + 1).letter + r);
        tempCell.border = borderStyles;
        if ((c.type === "currency" || c.type === "absolute") && rowIndex > 0) {
          tempCell.numFmt =
            c.type === "currency"
              ? "€ #,##0.00;€ -#,##0.00;0"
              : "#,##0.00;#,##0.00;0";
        }
      });
    });
  } else {
    worksheet.getCell(`A${worksheet.rowCount + 1}`).value = getTranslation(
      "NO_DATA"
    );
  }
  return worksheet;
};
